var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteNotificationIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8292 6.17071C13.4447 5.7862 12.8212 5.78619 12.4367 6.17071L9.99993 8.60751L7.56312 6.17071C7.17861 5.7862 6.55518 5.7862 6.17067 6.17071C5.78615 6.55523 5.78615 7.17865 6.17067 7.56317L8.60747 9.99997L6.17067 12.4368C5.78615 12.8213 5.78615 13.4447 6.17067 13.8292C6.55518 14.2137 7.17861 14.2137 7.56312 13.8292L9.99993 11.3924L12.4367 13.8292C12.8212 14.2137 13.4447 14.2137 13.8292 13.8292C14.2137 13.4447 14.2137 12.8213 13.8292 12.4368L11.3924 9.99997L13.8292 7.56317C14.2137 7.17865 14.2137 6.55523 13.8292 6.17071Z",
    fill: "#DD6369"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNotificationIconError);
export default __webpack_public_path__ + "static/media/delete_notification_icon_error.76d226909195b4a58d6685c78c47363a.svg";
export { ForwardRef as ReactComponent };